import { Resource } from "./Resource";
export class Prefab extends Resource {
    constructor() {
        super(false);
        this.fromDCC = false;
        this._traceDeps = true;
    }
    onLoad() {
        Resource._idResourcesMap[this._id] = this;
        return this;
    }
    create(options, errors) {
        return null;
    }
}
export var HierarchyResource = Prefab;
